export default "__VITE_ASSET__CtZMVuoG__"